import _ from 'lodash'
import * as React from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Button, Typography as MIUTypography, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import * as rt from '../../config/routeType'
import { useSelector, useDispatch } from 'react-redux'
import { setMarker } from '../../redux/slices/Map/map'
import { globalMapboxSettings as mbgls } from '../../utils'
import {
  Home,
  Forest,
  AddLocationAlt,
  AppRegistration,
  Summarize,
} from '@mui/icons-material'

const FONTSIZE_TEXT = '0.9em'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  position: 'relative',
  lineHeight: 2,
  fontSize: FONTSIZE_TEXT,
  fontWeight: 700,
  color: 'var(--color-black)',
  bottom: props.hgt ? `calc(${props.hgt} - calc(${props.hgt} / 4))` : 'none',
  width: '100%',
  '&:hover': { color: 'var(--color-black)' },
}))

const active = {
  height: 0,
  borderRadius: '2px',
  textDecoration: 'none',
  border: '2.4px solid #fbcd05',
}

const inactive = {
  height: 0,
  textDecoration: 'none',
  border: '2px solid transparent',
  display: 'none',
}

const styleLink = {
  color: 'rgba(25, 118, 210, 0.04)',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'end',
  '&:hover': {
    color: '#fbcd05',
  },
}

const IconBreadcrumbs = ({ authenticated, windowWidth }) => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const location = useLocation()

  const manageRecordsRute = `/${rt.MANAGEMENT_TREE}/${rt.TREE}`
  const registerRute = `/${rt.MANAGEMENT_TREE}/${rt.TREE}/${rt.REGISTER_TREE}`
  const tableManagement = `/${rt.MANAGEMENT_TREE}/${rt.TABLE_RECORDS}`
  const reportRute = `/${rt.GENERATE_REPORT}`
  const informationRute = `/${rt.INFORMATION}`

  const _state = useSelector(state => state.drawerLeft)
  const propsIcons = { fontSize: 'inherit', sx: { stroke: 'black' } }
  const propsLink = { component: 'div', underline: 'none', sx: styleLink }

  const styleButton = {
    py: 0,
    top: `calc(calc(${_state.drawerHeight} - ${FONTSIZE_TEXT}) / 2)`,
    alignItems: 'end',
    pr: Boolean(authenticated)
      ? 0
      : _.startsWith(location.pathname, '/tree') || location.pathname === '/'
      ? 4
      : 0,
    minWidth: 0,
  }

  const styleEndButton = rute => ({
    ...styleButton,
    pr: Boolean(authenticated) ? 0 : _.eq(rute, location.pathname) ? 4 : 0,
  })

  const handleOnClickMain = () => {
    dispatch(setMarker({ openMarker: false, draggable: false, lnglat: [] }))
    window.removeEventListener('beforeunload', function (event) {
      event.preventDefault()
      event.returnValue = '¿Estás seguro de que deseas abandonar esta página?'
    })
    window.addEventListener('keydown', function (e) {
      if (e.key === 'U+0052' || (e.ctrlKey && e.key === 'r') || e.key === 'F5')
        e.preventDefault()
    })
    window.localStorage.setItem('arbolQR_Map_Zoom', mbgls.zoom)
    window.localStorage.setItem('arbolQR_Map_lng', mbgls.lng)
    window.localStorage.setItem('arbolQR_Map_lat', mbgls.lat)
    navigate('/', { replace: true })
    navigate(0, { replace: true })
  }
  const handleOnClickManageRecordsRute = () => {
    dispatch(setMarker({ openMarker: false, draggable: false, lnglat: [] }))
    if (_.includes([registerRute, tableManagement], location.pathname))
      navigate(manageRecordsRute, { replace: true })
  }

  if (windowWidth < 750)
    return (
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb-home">
          <Tooltip
            title={location.pathname !== '/tree' ? 'Inicio' : ''}
            placement="bottom">
            <Link {...propsLink} onClick={handleOnClickMain}>
              <Home {...propsIcons} />
              <Button
                id="inicio"
                sx={{
                  ...styleButton,
                  pr: 4,
                }}>
                <NavLink
                  to={'/tree'}
                  style={({ isActive }) =>
                    isActive ? active : { ...inactive, display: 'block' }
                  }>
                  <Typography hgt={_state.drawerHeight}>Inicio</Typography>
                </NavLink>
              </Button>
            </Link>
          </Tooltip>
        </Breadcrumbs>
      </div>
    )

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Tooltip title={location.pathname !== '/tree' ? 'Inicio' : ''} placement="bottom">
          <Link {...propsLink} onClick={handleOnClickMain}>
            <Home {...propsIcons} />
            <Button id="inicio" sx={styleButton}>
              <NavLink
                to={'/tree'}
                style={({ isActive }) => (isActive ? active : inactive)}>
                <Typography hgt={_state.drawerHeight}>Inicio</Typography>
              </NavLink>
            </Button>
          </Link>
        </Tooltip>

        {_.startsWith(location.pathname, manageRecordsRute) && (
          <Tooltip
            title={
              _.includes([registerRute, tableManagement], location.pathname)
                ? 'Administrar registros'
                : ''
            }
            placement="bottom">
            <Link {...propsLink} onClick={handleOnClickManageRecordsRute}>
              <Forest {...propsIcons} />
              {!_.eq(location.pathname, registerRute) && (
                <Button id="administrar-registros" sx={styleEndButton(manageRecordsRute)}>
                  <NavLink style={({ isActive }) => (isActive ? active : inactive)}>
                    <Typography hgt={_state.drawerHeight}>
                      {windowWidth < 775 ? 'Admin. registros' : 'Administrar registros'}
                    </Typography>
                  </NavLink>
                </Button>
              )}
            </Link>
          </Tooltip>
        )}

        {_.eq(location.pathname, registerRute) && (
          <Link {...propsLink}>
            <AddLocationAlt {...propsIcons} />
            <Button id="registrar-arbol" sx={styleEndButton(registerRute)}>
              <NavLink
                to={registerRute}
                style={({ isActive }) => (isActive ? active : inactive)}>
                <Typography hgt={_state.drawerHeight}>Registrar árbol</Typography>
              </NavLink>
            </Button>
          </Link>
        )}
        {_.eq(location.pathname, tableManagement) && (
          <Link {...propsLink}>
            <AppRegistration {...propsIcons} />
            <Button id="administracion-global" sx={styleEndButton(registerRute)}>
              <NavLink
                to={tableManagement}
                style={({ isActive }) => (isActive ? active : inactive)}>
                <Typography hgt={_state.drawerHeight}>
                  {windowWidth < 775 ? 'Admin. global' : 'Administración Global'}
                </Typography>
              </NavLink>
            </Button>
          </Link>
        )}
        {_.eq(location.pathname, reportRute) && (
          <Link {...propsLink}>
            <Summarize {...propsIcons} />
            <Button id="generar-reporte" sx={styleEndButton(reportRute)}>
              <NavLink
                to={reportRute}
                style={({ isActive }) => (isActive ? active : inactive)}>
                <Typography hgt={_state.drawerHeight}>Generar Reporte</Typography>
              </NavLink>
            </Button>
          </Link>
        )}
        {_.eq(location.pathname, informationRute) && (
          <Link {...propsLink}>
            <Summarize {...propsIcons} />
            <Button id="informacion" sx={styleEndButton(informationRute)}>
              <NavLink
                to={informationRute}
                style={({ isActive }) => (isActive ? active : inactive)}>
                <Typography hgt={_state.drawerHeight}>Información</Typography>
              </NavLink>
            </Button>
          </Link>
        )}
      </Breadcrumbs>
    </div>
  )
}

export default IconBreadcrumbs
